import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { PaywallProvider } from "@/contexts/PaywallContext";
import { PlayerProvider } from "@/contexts/PlayerContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import Library from "@/pages/Library";
import Album from "@/pages/Album";
import Artist from "@/pages/Artist";
import Playlist from "@/pages/Playlist";
import Premium from "@/pages/Premium";
import Account from "@/pages/Account";
import Settings from "@/pages/Settings";
import SubmitArtist from "@/pages/SubmitArtist";
import AdminSubmissions from "@/pages/AdminSubmissions";
import AdminClaims from "@/pages/AdminClaims";
import AdminUsers from "@/pages/AdminUsers";
import AdminHome from "@/pages/AdminHome";
import PublicPlaylist from "@/pages/PublicPlaylist";
import ComingSoon from "@/pages/ComingSoon";
import Upload from "@/pages/Upload";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import Artists from "@/pages/Artists";
import AuthCallback from "@/pages/AuthCallback";
import ARDashboard from "@/pages/ARDashboard";
import ArtistBadge from "@/pages/ArtistBadge";
import Promote from "@/pages/Promote";
import RadarPage from "@/pages/Radar";
import About from "@/pages/About";
import Jobs from "@/pages/Jobs";
import Investors from "@/pages/Investors";
import Communities from "@/pages/Communities";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Auth callback (synchronous, before normal routes)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/p/:id" element={<PublicPlaylist />} />
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/library" element={<Library />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:userId" element={<Profile />} />
        <Route path="/account/payouts" element={<Profile />} />
        <Route path="/artists" element={<Artists />} />
        <Route path="/album/:id" element={<Album />} />
        <Route path="/artist/:id" element={<Artist />} />
        <Route path="/playlist/:id" element={<Playlist />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/account" element={<Account />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/submit-artist" element={<SubmitArtist />} />
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/submissions" element={<AdminSubmissions />} />
        <Route path="/admin/claims" element={<AdminClaims />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/ar" element={<ARDashboard />} />
        <Route path="/badge" element={<ArtistBadge />} />
        <Route path="/promote" element={<Promote />} />
        <Route path="/radar" element={<RadarPage />} />
        <Route path="/hotspot" element={<RadarPage />} />
        {/* Footer pages — Company / Communities / Plans */}
        <Route path="/about" element={<About />} />
        <Route path="/company" element={<About />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/careers" element={<Jobs />} />
        <Route path="/investors" element={<Investors />} />
        <Route path="/communities" element={<Communities />} />
        <Route path="/plans" element={<Premium />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PaywallProvider>
          <PlayerProvider>
            <AppRouter />
            <Toaster
              position="bottom-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "rgba(20,20,20,0.95)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#fff",
                },
              }}
            />
          </PlayerProvider>
        </PaywallProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
